/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Temporarypasswordsentmessage3Inputs */

const en_auth_temporarypasswordsentmessage3 = /** @type {(inputs: Auth_Temporarypasswordsentmessage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A temporary password has been sent to your inbox. Use it to sign in and complete your account setup.`)
};

/**
* | output |
* | --- |
* | "A temporary password has been sent to your inbox. Use it to sign in and complete your account setup." |
*
* @param {Auth_Temporarypasswordsentmessage3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_temporarypasswordsentmessage3 = /** @type {((inputs?: Auth_Temporarypasswordsentmessage3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Temporarypasswordsentmessage3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_temporarypasswordsentmessage3(inputs)
});
export { auth_temporarypasswordsentmessage3 as "auth_temporaryPasswordSentMessage" }